import gql from 'graphql-tag'

export const GET_RISK_PROFILE_SCORE = gql`
  query GetRiskProfile {
    getRiskProfile
  }
`
